<template>
    <base-modal
        hide-header
        hide-footer
        size="lg"
        @close="$emit('close')"
    >
        <div class="col-sm-12 editor-form d-flex flex-column" style="height: 85vh; overflow-y: hidden !important;">
            <header class="flex-shrink-0 border-bottom">
                <h3
                    v-if="!roadSign"
                    class="editor-header"
                >
                    {{ $t('road_sign.add_new') }}
                </h3>
                <h3
                    v-else
                    class="editor-header"
                >
                    {{ $t('road_sign.edit') }}
                </h3>
                <div
                    v-if="roadSign && roadSign.location_deviation"
                    class="col-12 nopads pl-3"
                >
                    <location-deviation :location-deviation="roadSign.location_deviation" />
                </div>
            </header>
            <!-- Scrollable content -->
            <main class="flex-grow-1 overflow-auto px-1">
                <div class="col-sm-12 editor-form pt-3" style="overflow-x: hidden">
                        <div
                            v-if="roadSign && !roadSign.external_system"
                            class="stat-container nopads"
                        >
                            <Flicking
                                v-if="roadSign && roadSign.photos && roadSign.photos.length > 0"
                                ref="flicking"
                                :options="options"
                                :plugins="plugins"
                                class="pointer nopads text-center"
                                style="height: 15em;"
                            >
                                <ImageView
                                    v-for="photo in roadSign.photos"
                                    :key="photo.id"
                                    ref="image"
                                    class="flicking-panel"
                                    :contain="true"
                                    :url="getPhotoUrl(roadSignPhotoUrl, photo)"
                                    :control-size="`sm`"
                                    @click="openImage"
                                />
                                <template #viewport>
                                    <div class="flicking-pagination" />
                                </template>
                            </Flicking>
                            <div
                                v-else
                                style="padding-top: 6em; height: 15em; text-align: center"
                            >
                                {{ $t('power_stations.no_photos') }}
                            </div>
                        </div>
                        <div class="col-sm-12 container form-data px-0">
                            <div>
                                <div class="row">
                                    <div
                                        v-if="isExternalRoadSign"
                                        class="col-sm-6 nopads pl-1 pr-1"
                                    >
                                        <span class="span-title">{{ $t('common.id') }}</span>
                                        <span class="item-detail-text">{{ roadSign.external_system_id }}</span>
                                    </div>
                                    <div
                                        v-else
                                        class="col-sm-6 nopads pl-1 pr-1"
                                    >
                                        <span class="span-title">{{ $t('common.id') }}</span>
                                        <span class="item-detail-text">{{ roadSign && roadSign.id }}</span>
                                    </div>
                                    <div
                                        v-if="roadSign"
                                        class="col-sm-6 nopads pl-1 pr-1"
                                    >
                                        <road-addess-view
                                            :road-number="roadSign.road_num"
                                            :section-number="roadSign.sec_num"
                                            :distance="roadSign.distance"
                                            :street-name="roadSign.road_name"
                                        />
                                    </div>
                                </div>
                                <span class="span-title">{{ $t('road_sign.sign_type') }}</span>
                                <select
                                    v-model="type"
                                    class="form-select form-select-sm"
                                    :disabled="isExternalRoadSign"
                                >
                                    <option
                                        :value="null"
                                        disabled
                                    >
                                        {{ $t('road_sign.select_sign_type') }}
                                    </option>
                                    <option
                                        v-for="item in getRoadSignTypes()"
                                        :key="item.value"
                                        :value="item.value"
                                    >
                                        {{ item.name }}
                                    </option>
                                </select>
                                <span class="span-title">{{ $t('road_sign.road_sign') }}</span>
                                <multiselect
                                    v-model="sign"
                                    :placeholder="$t('road_sign.select_sign')"
                                    :deselect-label="$t('common.remove_selection')"
                                    :select-label="$t('common.select')"
                                    :close-on-select="true"
                                    :multiple="false"
                                    label="name"
                                    track-by="name"
                                    :searchable="true"
                                    :internal-search="true"
                                    :selected-label="$t('common.selected')"
                                    :options="signs"
                                    :disabled="isExternalRoadSign"
                                >
                                    <template #singleLabel="props">
                                        <div class="d-flex align-items-center">
                                            <div class="me-2">
                                                <div style="position: relative; display: inline-block; margin: 0; padding: 0; width: 2em; height: 2em">
                                                    <img
                                                        class="option__image"
                                                        :src="getImageUrl(props.option.icon)"
                                                        alt=""
                                                        style="width: 100%; height: 100%; object-fit: contain"
                                                    >
                                                    <span
                                                        v-if="props.option.value === 'C32'"
                                                        style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: #000000; font-size: .8em; font-weight: bold;  text-align: center;"
                                                    >60</span>
                                                </div>
                                            </div>
                                            <div
                                                class="flex-grow-1"
                                                style="padding-top: 2px;"
                                            >
                                            <span
                                                class="option__title"
                                                style="font-weight: 400; text-align: left;"
                                            >
                                                {{ props.option.name }}
                                            </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #option="props">
                                        <div class="d-flex align-items-center">
                                            <div class="me-2">
                                                <div class="image-container">
                                                    <img
                                                        class="option__image"
                                                        :src="getImageUrl(props.option.icon)"
                                                        alt=""
                                                        style="height: 1.6em; width: 1.6em; object-fit: contain"
                                                    >
                                                    <span
                                                        v-if="props.option.value === 'C32'"
                                                        class="overlay-text"
                                                    >60</span>
                                                </div>
                                            </div>
                                            <div
                                                class="flex-grow-1"
                                                style="padding-top: 2px;"
                                            >
                                            <span
                                                class="option__title"
                                                style="font-weight: 400; text-align: left;"
                                            >
                                                {{ props.option.name }}
                                            </span>
                                            </div>
                                        </div>
                                    </template>

                                    <template #noResult>
                                        {{ $t('common.not_found') }}
                                    </template>
                                    <template #noOptions>
                                        {{ $t('common.no_results') }}
                                    </template>
                                </multiselect>

                                <div class="row nopads">
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.sign_value') }}</span>
                                        <input
                                            id="value"
                                            v-model="value"
                                            type="number"
                                            class="form-control form-control-sm"
                                            :placeholder="$t('road_sign.value_hint')"
                                        >
                                    </div>
                                    <div class="col-4">
                                        <span class="span-title">{{ $t('road_sign.road_direction') }}</span>
                                        <input
                                            id="value"
                                            v-model="roadDirection"
                                            type="number"
                                            min="1"
                                            max="3"
                                            :disabled="isExternalRoadSign"
                                            class="form-control form-control-sm"
                                        >
                                    </div>
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.sign_lane') }}</span>
                                        <input
                                            id="value"
                                            v-model="lane"
                                            type="number"
                                            min="1"
                                            :disabled="isExternalRoadSign"
                                            class="form-control form-control-sm"
                                        >
                                    </div>
                                </div>
                                <div class="row nopads">
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.installation') }}</span>
                                        <select
                                            v-model="installation"
                                            :disabled="isExternalRoadSign"
                                            class="form-select form-select-sm"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                {{ $t('road_sign.select_installation') }}
                                            </option>
                                            <option
                                                v-for="item in isExternalRoadSign ? getVelhoInstallations() : getInstallations()"
                                                :key="item.value"
                                                :value="item.value"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4">
                                        <span class="span-title">{{ $t('road_sign.side') }}</span>
                                        <select
                                            v-model="side"
                                            :disabled="isExternalRoadSign"
                                            class="form-select form-select-sm"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                {{ $t('road_sign.select_side') }}
                                            </option>
                                            <option
                                                v-for="item in getSides()"
                                                :key="item.value"
                                                :value="item.value"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.material') }}</span>
                                        <select
                                            v-model="material"
                                            class="form-select form-select-sm"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                {{ $t('road_sign.select_material') }}
                                            </option>
                                            <option
                                                v-for="item in getMaterials()"
                                                :key="item.value"
                                                :value="item.value"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row nopads">
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.sign_direction') }}</span>
                                        <div class="mb-3">
                                            <input
                                                id="value"
                                                v-model="signDirection"
                                                type="number"
                                                class="form-control form-control-sm"
                                                :placeholder="$t('road_sign.direction_hint')"
                                                :min="0"
                                                :max="359"
                                                :disabled="isExternalRoadSign"
                                                :required="!isExternalRoadSign"
                                            >
                                            <span class="tip-light form-label">{{ $t('road_sign.direction_hint') }}</span>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <span class="span-title">{{ $t('road_sign.condition') }}</span>
                                        <select
                                            v-model="condition"
                                            class="form-select form-select-sm"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                {{ $t('road_sign.select_condition') }}
                                            </option>
                                            <option
                                                v-for="item in getConditions()"
                                                :key="item.value"
                                                :value="item.value"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div
                                        v-if="isExternalRoadSign"
                                        class="col-4 nopads"
                                    >
                                        <span class="span-title">{{ $t('road_sign.order_number') }}</span>
                                        <input
                                            id="orderNumber"
                                            v-model="orderNumber"
                                            type="number"
                                            class="form-control form-control-sm"
                                            min="0"
                                        >
                                    </div>
                                </div>
                                <div
                                    v-if="isExternalRoadSign"
                                    class="row pb-2"
                                >
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.sign_width') }}</span>
                                        <input
                                            id="signWidth"
                                            v-model="width"
                                            type="number"
                                            step="any"
                                            class="form-control form-control-sm"
                                            min="0"
                                        >
                                    </div>
                                    <div class="col-4">
                                        <span class="span-title">{{ $t('road_sign.sign_height') }}</span>
                                        <input
                                            id="signHeight"
                                            v-model="height"
                                            type="number"
                                            step="any"
                                            class="form-control form-control-sm"
                                            min="0"
                                        >
                                    </div>
                                    <div class="col-4 nopads">
                                        <span class="span-title">{{ $t('road_sign.sign_color') }}</span>
                                        <select
                                            id="signColor"
                                            v-model="signColor"
                                            class="form-select form-select-sm"
                                        >
                                            <option
                                                :value="null"
                                                disabled
                                            >
                                                {{ $t('road_sign.select_sign_color') }}
                                            </option>
                                            <option
                                                v-for="item in getVelhoSignColors()"
                                                :key="item.value"
                                                :value="item.value"
                                            >
                                                {{ item.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!--    photo editor-->
                                <div
                                    v-if="!roadSign || !roadSign.external_system_id"
                                    class="pb-3"
                                >
                                    <span class="span-title">{{ $t('vehicle_editor.add_photo') }}</span>
                                    <!-- Photo editor-->
                                    <div class="col-12">
                                        <!-- Show selected photos -->
                                        <div
                                            v-for="(file, index) in photos"
                                            :key="index"
                                            class="d-flex align-items-center justify-content-between mb-3"
                                        >
                                            <span>{{ file?.name || file }}</span>
                                            <button
                                                class="btn btn-outline-danger btn-sm"
                                                type="button"
                                                @click="removePhoto(index)"
                                            >
                                                {{ $t('common.remove') }}
                                            </button>
                                        </div>

                                        <!-- Hidden file input -->
                                        <input
                                            ref="photoInput"
                                            type="file"
                                            accept="image/jpeg,image/jpg,image/png"
                                            class="visually-hidden"
                                            @change="handlePhotoChange"
                                        >

                                        <!-- Custom "Add photo" button -->
                                        <div class="col-12 d-flex justify-content-end">
                                            <button
                                                class="btn btn-outline-primary btn-sm"
                                                type="button"
                                                @click="triggerPhotoInput"
                                            >
                                                {{ $t('power_stations.add_photo') }}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    v-if="isExternalRoadSign"
                                    class="row nopads mb-4 mt-2"
                                >
                                    <div class="col-sm-12 nopads">
                                        <hr>
                                        <h4 class="form-header nopads mt-0">
                                            {{ $t('velho_equipment.location_spesifications') }}
                                        </h4>
                                        <velho-equipment-location-details-editor
                                            ref="equipmentLocationEditor"
                                            :road-info="velhoRoadInfo"
                                            :hide-road-info="true"
                                            :location-specification="velhoRoadSignLocationSpecification"
                                            :tracks-required="roadSignTrackRequired(velhoRoadSignLocationSpecification.center_area, velhoRoadSignLocationSpecification.side)"
                                            :side-required="roadSignSideRequired(roadSign.location_deviation, roadSign.road_num)"
                                            :ramp-required="locationSpecificationRequiredRoadSign('ramps')"
                                            :shoulder-required="locationSpecificationRequiredRoadSign('shoulders')"
                                            :platform-required="locationSpecificationRequiredRoadSign('platforms')"
                                            :edge-area-required="locationSpecificationRequiredRoadSign('edge_areas')"
                                            :divider-required="locationSpecificationRequiredRoadSign('dividers')"
                                            :ditch-bottom-required="locationSpecificationRequiredRoadSign('ditch_bottoms')"
                                            :center-area-required="locationSpecificationRequiredRoadSign('center_area')"
                                            :disable-rule="locationSpecificationDisableRule"
                                        />
                                    </div>
                                </div>

                                <hr>
                                <span class="span-title">{{ $t('road_sign.info') }}</span>
                                <div class="mb-3">
                                <textarea
                                    id="info"
                                    v-model="info"
                                    :placeholder="$t('road_sign.info')"
                                    rows="4"
                                    class="form-control"
                                    :style="{ 'max-height': 'calc(8 * 1.5rem)' }"
                                />
                                </div>

                                <span
                                    v-if="!isExternalRoadSign"
                                    class="span-title"
                                    style="text-transform: uppercase; font-size: .9em"
                                >{{
                                        $t('road_sign.contract_info')
                                    }}</span>
                                <open-contract-filter
                                    v-if="!isExternalRoadSign && !isLouhiSign"
                                    :to="toDate"
                                    :from="fromDate"
                                    :contract="contract"
                                    :show-company="false"
                                    style="margin-left: -2px; margin-right: -3px;"
                                    @loading="loading=true"
                                    @loading-completed="loading=false"
                                    @contract-selected="setContract"
                                />
                                <louhi-multiple-contracts-filter
                                    v-if="!isExternalRoadSign && isLouhiSign"
                                    v-model="signContracts"
                                    :editable="!loading"
                                    :show-only-louhi-contracts="true"
                                    style="margin-left: -2px; margin-right: -3px;"
                                    @loading="loading = true"
                                    @loading-completed="loading = false"
                                    @contract-selected="setContract"
                                />
                                <div
                                    v-if="isExternalRoadSign"
                                    class="row nopads"
                                >
                                    <div class="col-sm-12 nopads mt-2">
                                        <velho-equipment-damages :items="roadSign.equipment_damages" />
                                    </div>
                                </div>
                                <equipment-actions
                                    v-if="roadSign && roadSign.external_system_id"
                                    ref="actions"
                                    v-model="actions"
                                />
                                <linked-equipment
                                    v-if="roadSign && roadSign.linked_equipment.length > 0"
                                    :linked-equipments="roadSign.linked_equipment"
                                />
                                <hr>
                            </div>
                        </div>
                    </div>
            </main>
            <footer class="flex-shrink-0 p-3 border-top">
                <div class="col-sm-12 button-container">
                    <button
                        v-if="roadSign && !roadSign.external_system_id"
                        class="btn btn-info form-button"
                        @click.stop="openDrawGeometryWizard"
                    >
                        {{ $t('road_sign.change_location') }}
                    </button>
                    <button
                        :disabled="loading || roadSign===null"
                        class="btn btn-danger form-button"
                        @click.stop="removeSignModal = true"
                    >
                        {{ $t('road_sign.remove') }}
                    </button>
                    <button
                        class="btn btn-secondary form-button"
                        @click.stop="$emit('close')"
                    >
                        {{ $t('common.close') }}
                    </button>
                    <button
                        class="btn btn-success form-button"
                        :disabled="loading || (roadSign === null && coordinate === null)"
                        @click.stop="handleSave"
                    >
                        {{ $t('common.save') }}
                    </button>
                </div>
            </footer>
        </div>

        <draw-geometry-wizard
            v-if="showDrawGeometryWizard !== false"
            :saved-geometry="signCoordinates"
            :observation-mode="true"
            :type="OTHER"
            @close="closeDrawGeometryWizard"
            @add-drawn-geometry="addGeometryToRoadSign"
        />
        <base-modal
            v-if="removeSignModal"
            hide-header
            hide-footer
        >
            <div class="col-sm-12 pb-1">
                <h3 class="editor-header">{{ $t('road_sign.remove') }}</h3>
                <span>{{ $t('road_sign.remove_confirmation') }}</span>
                <div v-if="roadSign.external_system != 2" class="row">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('common.end_date')"
                            v-model="roadSign.removed_at"
                        />
                    </div>
                </div>
            </div>
            <div class="col-12 text-end">
                <button
                    class="btn btn-secondary form-button"
                    @click="removeSignModal = false"
                >
                    {{ $t('common.no') }}
                </button>
                <button
                    class="btn btn-success form-button"
                    @click="removeSign"
                >
                    {{ $t('common.yes') }}
                </button>
            </div>
        </base-modal>
        <base-modal
            v-if="replaceSignModal"
            :hide-header="true"
            :hide-footer="true"
            style="z-index: 100"
        >
            <div class="col-sm-12 pb-1">
                <h4>{{ $t('equipments.replace_title') }}</h4>
                <span>{{ $t('equipments.replace_descr') }}</span>
                <div class="row">
                    <div class="col-sm-6 nopads mt-2">
                        <equipment-date
                            :text="$t('common.end_date')"
                            v-model="removeDate"
                        />
                    </div>
                </div>
            </div>
            <div class="col-12 text-end">
                <button
                    class="btn btn-secondary form-button"
                    @click="replaceSignModal = false"
                >
                    {{ $t('common.no') }}
                </button>
                <button
                    size="sm"
                    class="btn btn-success"
                    :disabled="!removeDate"
                    @click="replaceSignModal = false; submit(true)"
                >
                    {{ $t('common.yes') }}
                </button>
            </div>
        </base-modal>
        <!-- Fullscreen photo -->
        <Transition name="fade">
            <fullscreen-image
                v-if="fullScreenPhotoData"
                :large-images="fullScreenPhotoData"
                :panel-index="panelIndex"
                @close="closePhoto"
            />
        </Transition>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </base-modal>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import BaseModal from '../BaseModal'
import {roadSignHelper} from "@/components/mixins/RoadSignMixin";
import {velhoHelper, deviations} from "@/components/mixins/VelhoMixin";
import {conversionModelHelper, equipmentActions} from "@/components/mixins/ConversionMixin";
import {timeUtils} from "@/components/mixins/TimeUtils";
import ImageView from "@/components/view/ImageView";
import FullscreenImage from "@/components/view/FullscreenImage";
import DrawGeometryWizard from "@/components/shapeimport/DrawGeometryWizard";
import {attachmentHelper} from "@/components/mixins/AttachmentMixin";
import EquipmentActions from "@/components/velho/EquipmentActions";
import LinkedEquipment from "@/components/velho/LinkedEquipment";
import LocationDeviation from "@/components/velho/LocationDeviation";
import VelhoEquipmentDamages from "@/components/velho/VelhoEquipmentDamages";
import {Pagination} from "@egjs/flicking-plugins";
import Flicking from "@egjs/vue3-flicking";
import RoadAddessView from "@/components/velho/RoadAddressView";
import VelhoEquipmentLocationDetailsEditor from "@/components/velho/VelhoEquipmentLocationDetailsEditor";
import VelhoLocationSpesificationModel from "@/models/integrations/velho/VelhoLocationSpesificationModel";
import {velhoValidationMixin} from "@/components/mixins/VelhoValidationMixin";
import {velhoRequiredMixin} from "@/components/mixins/VelhoRequiredMixin";
import {inject} from "vue";
import EquipmentDate from "@/components/velho/EquipmentDate.vue";
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import LouhiMultipleContractsFilter from "@/components/contract/external/LouhiMultipleContractsFilter.vue";
import {infraEquipmentHelper} from "@/components/mixins/InfraEquipmentMixin.js";
import {userHelper} from "@/components/mixins/UserMixin";

// Import all SVG images from roadsign directory
const imageModules = import.meta.glob('@/assets/roadsign/*.svg', { eager: true });

export default {
    name: 'RoadSignWizard',
    components: {
        OpenContractFilter,
        EquipmentDate,
        RoadAddessView,
        LocationDeviation, EquipmentActions, FullscreenImage,
        BaseModal, Flicking, ImageView, DrawGeometryWizard,
        LinkedEquipment, VelhoEquipmentDamages, VelhoEquipmentLocationDetailsEditor, LouhiMultipleContractsFilter,

    },
    mixins: [restApi, roadSignHelper, timeUtils, attachmentHelper, conversionModelHelper, velhoHelper, velhoValidationMixin, userHelper,
        infraEquipmentHelper, velhoRequiredMixin],
    props: {
        selectedContract: {
            type: Object,
            default: null
        },
        coordinate: {
            type: Object,
            default: null
        },
        roadSign: {
            type: Object,
            default: null
        },
        user: {
            type: Object,
            default: null
        }
    },
    emits: ['close', 'closeAndUpdate'],
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert')
        return { showAlert }
    },
    data: function () {
        return {
            loading: false,
            contract: null,
            signContracts: [],
            type: null,
            sign: null,
            value: null,
            orderNumber: null,
            width: null,
            height: null,
            signColor: null,
            lane: 1,
            roadDirection: 1,
            replaceSignModal: false,
            showDrawGeometryWizard: false,
            signCoordinates: null,
            removeDate: null,
            signs: [],
            actions: [],
            installation: null,
            signDirection: null,
            side: null,
            material: null,
            condition: null,
            info: "",
            fullScreenPhotoData: null,
            removeSignModal: false,
            velhoRoadSignLocationSpecification: new VelhoLocationSpesificationModel(),
            velhoRoadInfo: {
                road_num: null,
                road_sec: null,
                distance: null
            },
            photos: [],
            plugins: [new Pagination({ type: 'bullet' })],
            options: {
                preventDefaultOnDrag: true,
                circular: true,
                panelsPerView: 1
            },
            panelIndex: 0,

        }
    },
    computed: {
        fromDate() {
            if (this.roadSign) {
                return this.roadSign.created_at
            }
            let d = new Date()
            return d.toISOString()
        },
        toDate() {
            let d = new Date()
            return d.toISOString()
        },
        isExternalRoadSign() {
            return this.roadSign && !!this.roadSign.external_system_id
        },
        isLouhiSign() {
            if (this.roadSign) {
                //existing
                return this.roadSign.external_system === 2
            } else {
                //creating new
                return this.hasLouhiInfra(this.user)
            }
        }
    },
    watch: {
        type: function (value) {
            if (value === null) {
                this.sign = null
                this.signs = []
            } else {
                this.signs = this.getSigns(this.type)
            }
        },
        'roadSign.location_deviation': function () {
            // if deviation is "at the end of the road", clear side selection because it cannot be set in this case
            if(this.roadSign.location_deviation === deviations.AT_THE_END_OF_THE_ROAD) {
                this.velhoRoadSignLocationSpecification.side = null
            }
            // Side is required when deviation is given (unless it is "at the end of the road"). Clear any other location specification selections
            if(this.roadSign.location_deviation != null) {
                this.velhoRoadSignLocationSpecification.ramps = null
                this.velhoRoadSignLocationSpecification.shoulders = null
                this.velhoRoadSignLocationSpecification.platforms = null
                this.velhoRoadSignLocationSpecification.edge_areas = null
                this.velhoRoadSignLocationSpecification.ditch_bottoms = null
                this.velhoRoadSignLocationSpecification.dividers = null
                this.velhoRoadSignLocationSpecification.center_area = null
            }
        }
    },
    mounted() {
        if (this.roadSign) {
            this.type = this.getSignType(this.roadSign.sign)
            this.$nextTick(() => this.sign = this.signs.find(item => item.value === this.roadSign.sign))
            this.value = this.roadSign.value
            this.lane = this.roadSign.lane
            this.roadDirection = this.roadSign.direction
            this.contract = this.roadSign.contract
            this.removeDate = this.roadSign.removed_at
            this.signCoordinates = {lat: this.roadSign.position.y, lng: this.roadSign.position.x}
            this.info = this.roadSign.info
            this.signColor = this.roadSign.sign_color ? this.roadSign.sign_color : null
            this.orderNumber = this.roadSign.order_number
            this.width = this.roadSign.sign_width
            this.height = this.roadSign.sign_height

            this.velhoRoadInfo = {
                road_num: this.roadSign.road_num,
                road_sec: this.roadSign.sec_num,
                distance: this.roadSign.distance
            }
            if (this.roadSign.installation) {
                this.installation = this.roadSign.installation
            }
            if (this.roadSign.sign_direction) {
                this.signDirection = this.roadSign.sign_direction
            }
            if (this.roadSign.side) {
                this.side = this.roadSign.side
            }
            if (this.roadSign.material) {
                this.material = this.roadSign.material
            }
            if (this.roadSign.sign_condition) {
                this.condition = this.roadSign.sign_condition
            }
            if (this.roadSign.actions) {
                this.actions = this.roadSign.actions
            }
            if(this.roadSign.location_specification) {
                this.velhoRoadSignLocationSpecification = new VelhoLocationSpesificationModel(this.roadSign.location_specification)
            }
            if(this.isLouhiSign) {
                this.signContracts = this.roadSign.contracts
            }
        } else {
            this.signCoordinates = this.coordinate
            if(this.selectedContract && Object.keys(this.selectedContract).length !== 0) {
                this.contract = this.selectedContract
            }
        }
    },
    methods: {

        triggerPhotoInput() {
            this.$refs.photoInput?.click();
        },
        handlePhotoChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.photos.push(file);
            }
            // Clear input value so the same file can be selected again if needed
            event.target.value = '';
        },
        removePhoto(index) {
            this.photos.splice(index, 1);
        },
        getImageUrl(fileName) {
            try {
                // Find the matching module
                for (const [path, module] of Object.entries(imageModules)) {
                    if (path.includes(fileName)) {
                        return module.default || module;
                    }
                }
                console.warn('Image not found:', fileName);
                return ''; // or a fallback image path
            } catch (e) {
                console.warn('Image not found:', fileName, e);
                return ''; // or a fallback image path
            }
        },

        handleFileChange(event, counter) {
            const file = event.target.files[0];
            if (file) {
                // Update the photos array with the selected file - Vue 3 way
                this.photos[counter] = file;
            }
        },

        handleSave() {
            // Check that the sign is Velho sign
            if(this.roadSign && this.roadSign.external_system_id) {
                if(this.actions.includes(equipmentActions.REPLACE) || this.roadSign.linked_equipment.some(x => x.hasOwnProperty("actions") && !!x.actions.find(y => y.value === equipmentActions.REPLACE))) {
                    this.replaceSignModal = true
                } else {
                    this.submit(false)
                }
            } else {
                // The sign is Routa own sign or new sign
                this.submit(false)
            }
        },
        submit(replace = false) {
            if (replace && !this.removeDate) {
                return
            }
            this.loading = true
            let params = {}
            if (this.roadSign && this.roadSign.external_system_id && this.selectedContract) {
                params.contract = {
                    'id': this.selectedContract.id,
                    'external_contract_id': this.selectedContract.external_contract ? this.selectedContract.external_contract.external_id : null
                }
            } else if ((!this.roadSign ||  !this.roadSign.external_system_id) && this.contract) {
                params.contract = {
                    'id': this.contract.id,
                }
            }
            params.direction = this.roadDirection
            params.lane = this.lane
            params.value = this.value
            if(this.sign && this.sign.value) {
                params.sign = this.sign.value
            }
            params.position = {
                lat: this.signCoordinates.lat,
                lon: this.signCoordinates.lng
            }
            if (this.roadSign && this.roadSign.id && this.roadSign.id > 0) {
                params.id = this.roadSign.id
            } else if(this.roadSign && this.roadSign.external_system_id) {
                params.equipment_damages = this.roadSign.equipment_damages ? this.roadSign.equipment_damages : []
                params.external_system_id = this.roadSign.external_system_id
                params.location_specification = this.velhoRoadSignLocationSpecification.toJSON()
            }
            if(this.roadSign && this.roadSign.linked_equipment.length > 0) {
                params.linked_equipment = this.roadSign.linked_equipment
            }
            params.removed_at = this.removeDate
            params.installation = this.installation
            params.side = this.side
            params.sign_condition = this.condition
            params.material = this.material
            params.info = this.info
            params.sign_direction = this.signDirection
            params.actions = this.actions
            params.order_number = this.orderNumber
            params.sign_width = this.width
            params.sign_height = this.height
            params.sign_color = this.signColor
            if(this.isLouhiSign) {
                const selectedIds = this.normalizeIds(this.signContracts)
                params.contract_ids = selectedIds
            }

            if(replace) {
                this.restAdd(this.extEquipmentsReplaceUrl, [params], this.uploadCompleted, this.fail)
            } else {
                if ((params.id && params.id > 0) || (params.external_system_id)) {
                    this.restUpdate(this.isExternalRoadSign ? this.roadSignExtUrl : this.roadSignUrl, params, this.success, this.fail)
                } else {
                    this.restAdd(this.roadSignUrl, params, this.success, this.fail)
                }
            }
        },
        openDrawGeometryWizard() {
            this.showDrawGeometryWizard = true
        },
        closeDrawGeometryWizard() {
            this.showDrawGeometryWizard = false
        },
        addGeometryToRoadSign(geometry) {
            if(geometry && geometry.point && geometry.point.lat && geometry.point.lon) {
                this.signCoordinates = {lat: geometry.point.lat, lng: geometry.point.lon}
            }
            this.closeDrawGeometryWizard()
        },
        success: function (response) {
            let photos = this.getValidAttachments(this.photos)
            if (photos.length > 0) {
                this.uploadPhoto(photos, response.id)
            } else {
                this.uploadCompleted()
            }
        },
        uploadPhoto: function (photos, id) {
            if (photos.length > 0) {
                this.loading = true
                let formData = new FormData()
                photos.forEach(photoFile => {
                    if (photoFile !== undefined && photoFile !== null) {
                        formData.append('photos[]', photoFile)
                    }
                })
                this.restPostWithFile(this.roadSignPhotoUrl + id, {}, formData, this.uploadCompleted, this.fail)
            }
        },
        uploadCompleted: function () {
            this.loading = false
            this.showAlert(this.$t(this.roadSign && (this.roadSign.id || this.roadSign.external_system_id) ? 'common.alert_update_success' :  'road_sign.added'), 'success')
            this.$emit('closeAndUpdate')
        },
        fail: function () {
            this.loading = false
            this.showAlert(this.$t('common.alert_add_failed'))
        },
        setContract: function (contract) {
            this.contract = contract
        },
        removeSign() {
            if(this.roadSign.external_system === 1) {
                // Velho
                this.removalConfirmed(null, this.roadSign, this.selectedContract)
            } else if (this.roadSign.external_system === 2) {
                // Louhi
                const LOUHI_SIGN = 'liikennemerkki';
                this.loading
                this.restDelete(this.extLouhiEquipmentUrl + '/' + LOUHI_SIGN + '/' + this.roadSign.id, this.handleRemoval, this.fail)
            } else {
                // Routa own sign
                this.removeDate = this.roadSign.removed_at
                this.submit()
            }
            this.removeSignModal = false
        },

        handleRemoval() {
            this.loading = false
            this.$emit('closeAndUpdate')
        },

        getPhotoUrl: function (baseUrl, photo) {
            return baseUrl + 'url/' + this.roadSign.id + '/' + photo.id
        },
        openImage: function () {
            const flicking = this.$refs.flicking
            const imageData = this.$refs.image
            this.fullScreenPhotoData = []
            imageData.forEach(src => {
                this.fullScreenPhotoData.push(src)
            })
            this.panelIndex = flicking.index

        },
        closePhoto() {
            this.fullScreenPhotoData = undefined
        },
        hasSomeLocationSpecificationSet(name) {
            const ruleFields = ['side', 'ramps', 'shoulders', 'platforms', 'edge_areas', 'ditch_bottoms', 'dividers', 'center_area'];
            // Velho allow only one of these values to be selected
            const otherSelections = ruleFields.filter(field => field !== name)
            return otherSelections.some(field => this.velhoRoadSignLocationSpecification[field] != null)
        },
        locationSpecificationRequiredRoadSign(name) {
            return !this.hasSomeLocationSpecificationSet(name) && this.roadSignLocationSpecificationRequired(this.roadSign.location_deviation, this.roadSign.road_num)
        },
        /**
         * Disable rule for location specification fields unless they are required
         * @param name - Location specification object key name
         * @returns {string}
         */
        locationSpecificationDisableRule(name) {
            // Disable side if location deviation is at the end of the road
            if(name === 'side' && this.roadSign.location_deviation === deviations.AT_THE_END_OF_THE_ROAD) {
                return true
            }

            // If side is required, disable all other location specifications
            if(name !== 'side' && this.roadSignSideRequired(this.roadSign.location_deviation, this.roadSign.road_num)) {
                return true
            }

            // Location specification is not allowed if road number is >= 20 000 and location deviation is set
            if(name !== 'side' && this.validateIsRoadSignLocationSpecificationNotAllowed(this.roadSign.road_num, this.roadSign.location_deviation)) {
                return true
            }

            // Otherwise check that only one of the following fields are selected
            return this.hasSomeLocationSpecificationSet(name)
        },

    }
}
</script>
<style lang="scss" scoped>
@import "../../styles/modal.css";

.modal-container {
  min-width: 70%;
}

.flicking-panel {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%; /* Full height of the Flicking container */
  width: 100%; /* Full width of the Flicking container */
}

.flicking-panel-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain; /* Ensures image fits within the container and is fully visible */
}

.flicking-pagination-bullets-container {
  bottom: .5rem;
}
</style>
